import { store } from '../../../configureStore';
import { goToProcessStep } from '../../../redirection';
import {
  cartContactInfoIntg,
  getFlowType,
  getSession,
  isACPEligibile,
  isCBandProQualifiedSession,
  isECJointTransactionFlow,
  isExpressCheckout,
  isPreorder,
  isVFEligibile,
  isSROPromo,
  sroPerkPricingMiniCartFFlag,
  isExpressCheckoutNSE,
  isExpressCheckoutFLow,
} from '../Helpers';
import { SETUP_OPTION_SELF, SETUP_OPTION_PROF } from '../../Web/DeviceSetup/constants';
import { VISION_FEATURE_CODE, NETMAX_PRODUCT_ID, SPL_DISCOUNT_PROMO_IDS } from './Constants';
import { PageList } from '../../../constants/pageList';
import { getQueryParams } from '../Helpers/queryParams';
import { validateUrl } from '../Helpers/xss';
import { apiUrls } from '../../../constants/apiUrl';

export const isSaveCartDisplay = (currentPageName, appId) => {
  const isSaveCart = currentPageName === 'cart' && !isACPEligibile() && !isVFEligibile() && appId !== 'AAL';
  return isSaveCart;
};

export const isHideViewCart = (currentPageName) => {
  const enableMiniCartPages = ['cart', 'revieworder', 'orderreview', 'confirmation'];
  const hideViewCart = enableMiniCartPages.includes(currentPageName);

  return hideViewCart;
};

export const isDisplayOneTimeCharges = (currentPageName, selectedSetup) => {
  const isOneTimeCharges =
    selectedSetup === 'Professional SetUp' && currentPageName !== 'setup' && currentPageName !== 'addons' && getFlowType() === '5G';

  return isOneTimeCharges;
};

const checkIsBTA = () => {
  const { checkout } = store.getState();
  const paymentOptions = checkout?.cart?.lineDetails?.payments;
  return (
    paymentOptions &&
    (paymentOptions.AC?.paymentType === 'AC' ||
      paymentOptions.CR?.paymentType === 'CR' ||
      paymentOptions.PY?.paymentType === 'PAYPAL' ||
      paymentOptions.PAYPAL?.paymentType === 'PAYPAL')
  );
};

const redirectToPage = (pageName) => {
  window.location.href = validateUrl(pageName);
};

const handleECJointransactionFlow = () => {
  const { processSteps } = store.getState();
  const isQueryStringPresent = !!getQueryParams()?.line;
  const isPreviousPageAddOn = processSteps?.Setup?.Cart?.previousStep === "Addons";
  const isCurrentPageSetup = processSteps?.Setup?.Cart?.currentStep === "Setup";
  const ecJointProfessionalSetupToAddon = isPreviousPageAddOn && !isQueryStringPresent;
  const ecJointProfessionalSetupToNextgenCart = isCurrentPageSetup && isQueryStringPresent;
  
  if(ecJointProfessionalSetupToAddon){
    redirectToPage(PageList.ADDONS);
  }
  else if (ecJointProfessionalSetupToNextgenCart){
    redirectToPage(`${apiUrls().redirectNextgenCart}`);
  }
}

const backBtnHandle = () => {
  const isECJointProfessionalFlow = isECJointTransactionFlow();

  if (isExpressCheckout() && !isECJointProfessionalFlow) {
    redirectToPage(PageList.EXPRESS_CHECKOUT);
  } else if(isECJointProfessionalFlow) {
    handleECJointransactionFlow();
  } else {
    redirectToPage(PageList.ADDONS);
  }
}

const expresscheckoutRedirect = () => {
  if (isExpressCheckoutNSE()) {
    window.location.href = PageList.CREDIT_CHECK;
  } else {
    window.location.href = PageList.ADDONS;
  }
}

const expresscheckoutRedirectForCreditcheck = (installType, updateView, processSteps) => {
  const isPreorderFlow = isPreorder();
  let localUpdateView = updateView;
  if (isExpressCheckoutNSE()) {
    window.location.href = PageList?.CONTACT_INFO;
  } else if (installType === SETUP_OPTION_SELF && !isPreorderFlow) {
    // If self then redirect to shipping
    localUpdateView = processSteps?.ContactInfo?.SELF || {};
  } else {
    // redirect to contactinfo page
    localUpdateView = processSteps?.Cart || {};
  }
  return localUpdateView;
};

const expresscheckoutRedirectForContactInfo = (processSteps) => {
  if (isExpressCheckoutNSE()) {
    window.location.href = PageList.ADDONS;
  } else {
    return processSteps?.Setup?.Cart || {};
  }
};

 const getBackButtonShippingCase = (updateView, processSteps, history) => {
  if (isExpressCheckoutFLow()) {
    window.location.href = PageList.EXPRESS_CHECKOUT;
  } else if (cartContactInfoIntg()) {
    history.push('/sales/home/cart.html');
    goToProcessStep(processSteps.Setup.SELF, history);
  } else {
    goToProcessStep(updateView, history);
  }
}

const handleCartBack = (flowType) => {
  if (flowType === '5G') {
    if (getSession('isCBandQual') === 'Y' && !isCBandProQualifiedSession()) {
      window.location.href = PageList.ADDONS;
    } else {
      window.location.href = PageList.SETUP;
    }
  } else {
    window.location.href = PageList.ADDONS;
  }
};

const handleAddonsBack = () => {
  const streamlineMVP2 = window.sessionStorage.getItem('widgetLQHost') === 'Streamline';
  window.location.href = streamlineMVP2 ? PageList.STREAMLINE_ORDER : PageList.PROGRESSIVE_PLAN;
};

const handleAppointmentBack = () => {
  if (isExpressCheckoutFLow()) {
    window.location.href = PageList.EXPRESS_CHECKOUT;
  } else {
    window.location.href = PageList.ORDER_REVIEW;
  }
};

const handleOrderReviewBack = (appId, installType, isPreorderFlow, processSteps, history) => {
  let updateView;
  if (appId === 'AAL') {
    if (installType === SETUP_OPTION_PROF) {
      updateView = cartContactInfoIntg() ? processSteps?.Setup?.SELF : processSteps?.Cart;
    } else if (installType === SETUP_OPTION_SELF && !isPreorderFlow) {
      updateView = processSteps?.ContactInfo?.SELF;
    } else {
      updateView = processSteps?.Cart;
    }
  } else {
    updateView = processSteps?.Shipping?.CreditCheck;
  }
  goToProcessStep(updateView, history);
};

const handleCreditCheckBack = (installType, processSteps, history) => {
  const updateView = expresscheckoutRedirectForCreditcheck(installType, undefined, processSteps);
  goToProcessStep(updateView, history);
};

const handleShippingBack = (processSteps, history) => {
  const updateView = processSteps?.Cart;
  getBackButtonShippingCase(updateView, processSteps, history);
};

const handlePaymentBack = (setUpType) => {
  if (isExpressCheckout()) {
    if (getSession('expChkOutPaymentEdit') === 'Y' || setUpType === 'Self SetUp') {
      window.location.href = PageList.EXPRESS_CHECKOUT;
    } else if (setUpType === 'Professional SetUp') {
      window.location.href = PageList.APPOINTMENT;
    }
  }
};

const handleExpressTosBack = (dueTodayAmount, setUpType) => {
  if (dueTodayAmount > 0 && !checkIsBTA()) {
    window.location.href = PageList.PAYMENT;
  } else if (setUpType === 'Self SetUp') {
    window.location.href = PageList.EXPRESS_CHECKOUT;
  } else if (setUpType === 'Professional SetUp') {
    window.location.href = PageList.APPOINTMENT;
  }
};

const PAGE_HANDLERS = {
  cart: (context) => handleCartBack(context.flowType),
  setup: () => backBtnHandle(),
  addons: () => handleAddonsBack(),
  appointment: () => handleAppointmentBack(),
  orderreview: (context) => handleOrderReviewBack(context.appId, context.installType, context.isPreorderFlow, context.processSteps, context.history),
  contactinfo: (context) => goToProcessStep(expresscheckoutRedirectForContactInfo(context.processSteps), context.history),
  creditcheck: (context) => handleCreditCheckBack(context.installType, context.processSteps, context.history),
  shipping: (context) => handleShippingBack(context.processSteps, context.history),
  payment: (context) => handlePaymentBack(context.setUpType),
  expresstos: (context) => handleExpressTosBack(context.dueTodayAmount, context.setUpType),
  expresscheckout: () => expresscheckoutRedirect(),
};

export const miniCartBackHandler = (currentPageName, appId, history, dueTodayAmount, setUpType) => {
  try {
    const { processSteps, deviceSetup } = store.getState();
    const context = {
      processSteps,
      installType: deviceSetup?.selectedOption || '',
      isPreorderFlow: isPreorder(),
      flowType: getSession('FlowType'),
      appId,
      history,
      dueTodayAmount,
      setUpType,
    };
    
    const handler = PAGE_HANDLERS[currentPageName];
    if (handler) {
      handler(context);
    } else {
      history.goBack();
    }
  } catch (error) {
    console.log('error in MiniCartBackHandler', error);
  }
};

export const perksPriceWithDiscount = (item) => {
  if (!item) return null;

  const { visFeatureCode, productId, discountsAndPromotions, featurePrice, totalAmountWithDiscount } = item;
  const { actualPrice, promos = [] } = discountsAndPromotions || {};

  const specialDiscountPromos = promos.filter((appliedDiscount) => SPL_DISCOUNT_PROMO_IDS.includes(appliedDiscount?.id));
  const isHavingSpecialDiscount = specialDiscountPromos.length > 0;
  const finalPrice = isHavingSpecialDiscount ? parseFloat(actualPrice ?? 0) - parseFloat(specialDiscountPromos[0]?.amountOff ?? 0) : 0;

  const isVisionOrNetmaxFeature = [VISION_FEATURE_CODE, NETMAX_PRODUCT_ID].includes(visFeatureCode);
  const isVisionOrNetmaxProduct = [VISION_FEATURE_CODE, NETMAX_PRODUCT_ID].includes(productId);

  // check for SRO perk promo
  const isSroEligiblePerk =  isPerkSroAvailable(promos);
  if (hasAnyOfPerk(discountsAndPromotions, isVisionOrNetmaxFeature, isVisionOrNetmaxProduct, isSroEligiblePerk)) {
    const price = isHavingSpecialDiscount ? finalPrice : parseFloat(actualPrice ?? 0);
    return price.toFixed(2);
  }

  if (isVisionOrNetmaxFeature || visFeatureCode) {
    return parseFloat(featurePrice ?? 0)?.toFixed(2);
  }

  if (isVisionOrNetmaxProduct || productId) {
    return parseFloat(totalAmountWithDiscount ?? 0)?.toFixed(2);
  }

  return null;
};

const hasAnyOfPerk = (discountsAndPromotions, isVisionOrNetmaxFeature , isVisionOrNetmaxProduct, isSroEligiblePerk) => (discountsAndPromotions && (isVisionOrNetmaxFeature || isVisionOrNetmaxProduct || isSroEligiblePerk));
const isPerkSroAvailable = (promos) => sroPerkPricingMiniCartFFlag() && promos?.some((promo) => isSROPromo(promo?.id));

export const getStrikeThroughPrice = (actualAmount, totalAmountWithDiscount) => {
  if (!actualAmount || actualAmount === 'null' || !totalAmountWithDiscount) return '';

  const actualPrice = parseFloat(actualAmount ?? 0)?.toFixed(2);
  const totalPriceWithDiscount = parseFloat(totalAmountWithDiscount ?? 0)?.toFixed(2);

  return actualPrice !== totalPriceWithDiscount ? actualPrice : '';
};
